import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import CKEditor from '@ckeditor/ckeditor5-vue';
import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css' // needs css-loader
import 'grapesjs/dist/css/grapes.min.css'
//import FlowChart from 'flowchart-vue';

import { BootstrapVue } from 'bootstrap-vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner,      faToggleOn,   faToggleOff,      faChevronLeft,    faChevronRight,
         faSort,         faList,       faFile,           faQuestionCircle, faSignOutAlt,    faBolt,           faHdd,
         faCogs,         faFilter,     faSave,           faTrash,          faCheck,         faEdit,           faPlug,          faWindowClose,
         faArrowUp,      faArrowDown,  faArrowRight,     faArrowLeft,      faPlus,          faMinus,          faRedo,          faPlay,   faStop,   faSearch,
         faVial,         faPuzzlePiece,faScroll,         faDownload,       faDiceOne,       faLayerGroup,     faExclamationTriangle,     faCog,    faPaintBrush,
         faBorderNone,   faUndo,       faEye } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// add font awesome icons
library.add(faSpinner,       faToggleOn,    faToggleOff,  faChevronLeft,faChevronRight,
            faSort,          faList,        faFile,       faSave,       faSignOutAlt,
            faQuestionCircle,faBolt,        faHdd,        faCogs,       faFilter,
            faTrash,         faCheck,       faEdit,       faPlug,       faArrowUp,     faWindowClose,
            faArrowDown,     faArrowRight,  faArrowLeft,  faPlus,        faMinus,      faRedo,       faPlay,       faStop,
            faSearch,        faVial,        faPuzzlePiece,faScroll,     faDownload,   faDiceOne,
            faLayerGroup,    faExclamationTriangle,       faCog,        faPaintBrush, faBorderNone,  faUndo,       faEye )
Vue.component('font-awesome-icon', FontAwesomeIcon)

// add bootstrap vue
Vue.use(VueLayers)
Vue.use(BootstrapVue)
//Vue.use(CKEditor);
//Vue.use(FlowChart);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
